module.exports = __webpack_public_path__ + "img/logo.d8ff52b0.jpg";